import * as R from 'ramda';

// common
import commonEn from '@/i18n/common/en';
import commonJa from '@/i18n/common/ja';
import commonZh from '@/i18n/common/zh';
import commonKr from '@/i18n/common/kr';

// b2b
import b2bEn from '@/i18n/b2b/en';
import b2bJa from '@/i18n/b2b/ja';
import b2bZh from '@/i18n/b2b/zh';
import b2bKr from '@/i18n/b2b/kr';

// b2c
import b2cEn from '@/i18n/b2c/en';
import b2cJa from '@/i18n/b2c/ja';
import b2cZh from '@/i18n/b2c/zh';
import b2cKr from '@/i18n/b2c/kr';

// internal
import internalEn from '@/i18n/internal/en';

const common = R.mergeAll([commonEn, commonZh, commonJa, commonKr]);
const b2b = R.mergeAll([b2bEn, b2bZh, b2bJa, b2bKr]);
const b2c = R.mergeAll([b2cEn, b2cZh, b2cJa, b2cKr]);
const internal = R.mergeAll([internalEn]);

const locales = R.reduce(R.mergeDeepWith(R.concat), common, [
  b2c,
  internal,
  b2b,
]);

export default locales;
